import {debounce} from 'lodash';

import mq from '../utils/media-queries';
import stackHeight from '../utils/stack-height';

import menuFlyout from '../modules/menu-flyout';
import bannerMenu from '../modules/banner-menu';
import searchToggle from '../modules/search-toggle';

export default {

  _bindEvents() {
    let debouncedUpdateShim = _.debounce(this.updateShim.bind(this), 200);
    window.addEventListener('resize', debouncedUpdateShim);
    window.addEventListener('popstate', debouncedUpdateShim.cancel);
  },

  init() {
    menuFlyout.init();
    bannerMenu.init();
    searchToggle.init();
    this.updateShim();
    this._bindEvents();
  },

  updateShim() {
    const header = document.getElementById('site-header');
    const headerShim = document.getElementById('header-shim');

    if ( mq.isMaxWidth('nav') ) {
      const height = stackHeight([
        header.querySelector('.site-header__promo-bar'),
        header.querySelector('.site-header__mobile-banner'),
        header.querySelector('.site-header__button'),
      ]);
      headerShim.style.height = `${height}px`;
    } else {
      headerShim.style.height = `${header.offsetHeight}px`;
    }
  },

}
